import axios from "axios";
import * as Constants from "../constant";
const setPassword = async (value) => {
	try {
		const response = await axios.patch(
			`${Constants?.LOCAL_URL}/userauth/updateInvite/${value.UserId}`,
			value
		);
		return response;
	} catch (error) {
		return error;
	}
};

export default setPassword;
